import { Ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { equalizeRowHeights } from '@/foundations/helpers/equalise-row-heights';

const useEqualHeights = (containerRef: Ref<HTMLElement | null>, selector: string) => {
  const equalize = () => equalizeRowHeights(containerRef, selector);

  onMounted(() => {
    window.addEventListener('resize', equalize);
    nextTick(equalize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', equalize);
  });

  return { equalize };
};

export default useEqualHeights;
